// import { combineReducers } from "redux";
import { RANGE, TAB } from "./constants";

const initialState = {
  currentTab: "1",
  dates: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TAB:
      return {
        ...state,
        dates: null,
        ...action.payload
      };

    case RANGE:
      return {
        ...state,
        currentTab: "5",
        dates: action.payload
      };
    // return {
    //   currentTab: action.payload
    // };

    default:
      return state;
  }
};
